import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import checkAuth from "./system/auth/authenticate.js";
Vue.use(Router);

// create new router

const routes = [
  {
    path: "/web",
    component: () => import("./views/menu"),
    redirect: "/web/home/dashboard",
    children: [
      {
        path: "home",
        beforeEnter: checkAuth,
        component: () => import("./views/home"),
        children: [
          {
            path: "dashboard",
            beforeEnter: checkAuth,
            component: () => import("./views/home/dashboard"),
          },
          {
            path: "news",
            beforeEnter: checkAuth,
            props: true,
            component: () => import("./views/home/news/news"),

          },
          {
            path: "newsDetails",
            name: 'newsDetails',
            beforeEnter: checkAuth,
            props: true,
            component: () => import("./views/home/news/newsDetails"),

          },

        ]
      },
      {
        path: "accounts",
        component: () => import("./views/accounts"),
        children: [
          {
            path: "create_trading_account",
            beforeEnter: checkAuth,
            component: () => import("./views/accounts/create_account"),
          },
          {
            path: "trading_accounts",
            beforeEnter: checkAuth,
            component: () => import("./views/accounts/trading_accounts"),
          },
          {
            path: "pamm_accounts",
            beforeEnter: checkAuth,
            component: () => import("./views/accounts/pamm_accounts"),
          },
           {
            path: "mamm_accounts",
            beforeEnter: checkAuth,
            component: () => import("./views/accounts/mamm_accounts"),
          },

        ]
      },
      {
        path: "traders",
        component: () => import("./views/traders"),
        children: [
          {
            path: "fund_management",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/fund_management"),
          },
          {
            path: "pammList",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/pammList"),
          },
          {
            path: "mammList",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/mammList"),
          },
          {
            path: "slaveWithdrawReq",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/slaveWithdrawReq"),
          },
          {
            path: "slaveDepositReq",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/slaveDepositReq"),
          },
          {
            path: "pammSlave",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/pammSlave"),
          },
          {
            path: "mammSlave",
            beforeEnter: checkAuth,
            component: () => import("./views/traders/mammSlave"),
          },

        ]
      },
      {
        path: "actions",
        component: () => import("./views/actions"),
        children: [
          {
            path: "convert",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/convert"),
          },
          {
            path: "usdt",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/usdt"),
          },
          {
            path: "fiat",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/fiat"),
          },
          {
            path: "transferToMT5Record",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/transferToMT5Record"),
          },
           {
            path: "withdrawFromEwalletRecord",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/withdrawFromEwalletRecord"),
          },
          {
            path: "deposit",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/depositCrypto"),
          },
           {
            path: "depositRecord",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/depositRecord"),
          },
          {
            path: "depositFiat",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/depositFiat"),
          },
           {
            path: "depositFiatRecord",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/depositFiatRecord"),
          },
          {
            path: "withdrawFiat",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/withdrawFiat"),
          },
           {
            path: "withdrawFiatRecord",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/withdrawFiatRecord"),
          }, 
          // {
          //   path: "walletWithdraw",
          //   beforeEnter: checkAuth,
          //   component: () => import("./views/actions/walletWithdraw"),
          // },
         
          {
            path: "cashWalletWithdraw",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/cashWalletWithdraw"),
          },
          {
            path: "walletWithdrawRecord",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/walletWithdrawRecord"),
          },  
        ]
      },
      {
        path: "network",
        component: () => import("./views/network"),
        children: [
          {
            path: "ib_network",
            beforeEnter: checkAuth,
            component: () => import("./views/network/ib_network"),
          },

        ]
      },
      {
        path: "report",
        component: () => import("./views/report"),
        children: [
          {
            path: "transaction",
            beforeEnter: checkAuth,
            component: () => import("./views/actions/transaction"),
          },
          {
            path: "wallet_transaction",
            beforeEnter: checkAuth,
            component: () => import("./views/report/wallet_transaction"),
          },
          {
            path: "ranking_bonus",
            beforeEnter: checkAuth,
            component: () => import("./views/report/ranking_bonus"),
          },
          {
            path: "overriding_bonus",
            beforeEnter: checkAuth,
            component: () => import("./views/report/overriding_bonus"),
          },
          {
            path: "static_bonus",
            beforeEnter: checkAuth,
            component: () => import("./views/report/static_bonus"),
          },

        ]
      },
      {
        path: "invest",
        beforeEnter: checkAuth,
        component: () => import("./views/menu/invest"),
      },
      {
        path: "wallet",
        beforeEnter: checkAuth,
        component: () => import("./views/menu/wallet"),
      },
      {
        path: "commission",
        beforeEnter: checkAuth,
        component: () => import("./views/menu/commission"),
      },
      {
        path: "profile",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/main"),
      },


    ]
  },
  {
    path: "/web/profile",
    component: () => import("./views/menu"),
    redirect: "/web/profile/main",
    children: [
      {
        path: "main",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/main.vue"),
      },
      {
        path: "kyc",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/kyc"),
      },
      {
        path: "security",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/security"),
      },
      {
        path: "bank-information",
        beforeEnter: checkAuth,
        component: () => import("./views/actions/createWalletAddress"),
      },

    ]
  },


  {
    path: "/web/investRecord",
    beforeEnter: checkAuth,
    component: () => import("./views/menu/investRecord"),
  },

  {
    path: "/web/walletDetails",
    name: 'walletDetails',
    beforeEnter: checkAuth,
    props: true,
    component: () => import("./views/menu/walletDetails"),

  },
  {
    path: "/web/deposit",
    beforeEnter: checkAuth,
    component: () => import("./views/actions/deposit"),

  },
  {
    path: "/web/depositRecord",
    beforeEnter: checkAuth,
    component: () => import("./views/actions/depositRecord"),

  },
  {
    path: "/web/transactionHistory",
    beforeEnter: checkAuth,
    component: () => import("./views/menu/transaction_history"),

  },
 
  {
    path: "/web/withdrawRecord",
    beforeEnter: checkAuth,
    component: () => import("./views/actions/withdrawRecord"),

  },
  {
    path: "/web/sessions",
    component: () => import("./views/sessions"),
    children: [
      {
        path: "login",
        component: () => import("./views/sessions/login"),
      },
      {
        path: "set_secpassword",
        component: () => import("./views/sessions/set_secpassword"),
      },
      {
        path: "forget_password",
        component: () => import("./views/sessions/forget_password"),
      },
      {
        path: "forget_secpassword",
        component: () => import("./views/sessions/forget_secpassword"),
      },
    ]
  },

  {
    path: "/register",
    component: () => import("./views/sessions/register"),
  },

  {
    path: "/coming_soon",
    component: () => import("./views/pages/coming_soon")
  },

  {
    path: "*",
    component: () => import("./views/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
// var liveChat = document.getElementById('chat-widget-container');
router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.

  if (from.path.includes('manage')) {
    next();

  } else {
    if (to.path) {
      // Start the route progress bar.

      NProgress.start();
      NProgress.set(0.1);
    }
    next();

  }
});

router.afterEach(() => {
  var content = document.getElementById('top');
  if (content) {
    content.scrollTo({ top: 0, behavior: "smooth" });
  }
  // Remove initial loading
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  setTimeout(() => NProgress.done(), 100);
});

export default router;
